export default "__VITE_ASSET__DERRpB0z__"